import Immutable from 'seamless-immutable';
import { PERMISSIONS_TYPES } from './actions';
import { createReducer } from '../../libs/saga-utils';

const DEFAULT_STATE = {
  permissions: [],
  meta: {}
};

const ACTIONS = {
  [PERMISSIONS_TYPES.LOAD_ALL_SUCCESS]: loadAllSuccess,
  [PERMISSIONS_TYPES.LOAD_ALL_FAILURE]: loadAllFailure,
  [PERMISSIONS_TYPES.LOAD_ALL_REQUEST]: loadAllRequest
};

function loadAllSuccess(state, { payload }) {
  const permissions = payload.permissions.data;
  return state.merge({
    permissions,
    meta: payload.permissions.meta
  });
}

function loadAllFailure(state, { payload }) {
  return state;
}

function loadAllRequest(state, { payload }) {
  return state;
}

const permissionsReducer = createReducer(Immutable(DEFAULT_STATE), ACTIONS);

export default permissionsReducer;
